<template>
  <section class="l-content">
    <el-card>
      <el-form :inline="true" :model="condition">
        <el-form-item label="地点">
          <el-select v-model="condition.location_id" placeholder="选择地点" clearable style="width: 200px;">
            <el-option v-for="item in locationOptions" :key="item.location_id" :label="item.location_name" :value="item.location_id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="工人">
          <el-select v-model="condition.worker_id" placeholder="选择工人" clearable style="width: 200px;">
            <el-option v-for="item in workerOptions" :key="item.worker_id" :value="item.worker_id" label>{{item.worker_name}}</el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="condition.status" placeholder="选择状态" clearable style="width: 150px;">
            <el-option label="全部" :value="null"></el-option>
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期范围">
          <el-date-picker v-model="dateRange" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width: 260px;"></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="getPageData()">查询</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-divider></el-divider>
    <el-card v-if="pageData">
      <l-table :option="tableOption" :data="pageData.list" :start-index="pageData.startIndex">
        <template slot="status" slot-scope="scope">
          <el-tag :type="getStatusType(scope.row.status)">{{ getStatusText(scope.row.status) }}</el-tag>
        </template>
        <template slot="ai_pass" slot-scope="scope">
          <span v-if="scope.row.ai_score === null">-</span>
          <span :class="scope.row.ai_pass ? 'text-green' : 'text-red'">{{ scope.row.ai_score }}分</span>
        </template>
        <template slot="operation" slot-scope="scope">
          <el-button type="primary" size="mini" icon="el-icon-view" @click="viewDetail(scope.row)">详情</el-button>
          <el-button v-if="scope.row.status === 1" type="warning" size="mini" icon="el-icon-refresh" @click="triggerAiAudit(scope.row)">AI审核</el-button>
        </template>
      </l-table>
      <l-pager :page="pageData.page" @change="getPageData"></l-pager>
    </el-card>
  </section>
</template>

<script>
import { mapState } from 'vuex'
import detailTask from './taskDetail.vue'
export default {
  computed: {
    ...mapState(['userInfo'])
  },
  name: 'CleanTaskList',
  data() {
    return {
      tableOption: {
        stripe: true,
        height: document.documentElement.clientHeight - 330 + 'px',
        columns: [
          { label: '序号', type: 'index', width: 60 },
          { label: '区域', prop: 'locationInfo.area', width: 100 },
          { label: '地点名称', prop: 'location_name', width: 150 },
          { label: '工人姓名', prop: 'worker_name', width: 120 },
          { label: '打卡时间', prop: 'clock_in_time', width: 160 },
          { label: '提交时间', prop: 'submit_time', width: 160 },
          { label: 'AI打分', slot: 'ai_pass', width: 80 },
          { label: '申诉评分', prop: 'appeal_score', width: 80 },
          { label: '状态', slot: 'status', width: 120 },
          { label: 'AI原因', prop: 'ai_reason', minWidth: 200 },
          { label: '操作', slot: 'operation', width: 220 }
        ]
      },
      condition: {
        location_id: null,
        worker_id: null,
        status: null,
        pageIndex: 1,
        pageSize: 15
      },
      dateRange: [],
      pageData: null,
      locationOptions: [],
      workerOptions: [],
      statusOptions: [
        { value: 0, label: '已打卡未提交' },
        { value: 1, label: '已提交待审核' },
        { value: 2, label: 'AI审核通过' },
        { value: 3, label: 'AI审核不通过' },
        { value: 5, label: '申诉中' },
        { value: 6, label: '申诉通过' },
        { value: 7, label: '申诉不通过' }
      ]
    }
  },
  created() {
    this.loadOptions()
    this.getPageData()
  },
  methods: {
    async loadOptions() {
      this.locationOptions = await this.$lgh.get('api/clean/location/list', {
        enterpriseCode: this.userInfo.enterpriseCode
      }) || []
      this.workerOptions = await this.$lgh.get('api/clean/worker/list', {
        enterpriseCode: this.userInfo.enterpriseCode
      }) || []
    },
    getStatusType(status) {
      const map = {
        0: 'info',
        1: 'warning',
        2: 'success',
        3: 'danger',
        5: 'warning',
        6: 'success',
        7: 'danger'
      }
      return map[status] || 'info'
    },
    getStatusText(status) {
      const map = {
        0: '已打卡未提交',
        1: '已提交待审核',
        2: 'AI审核通过',
        3: 'AI审核不通过',
        5: '申诉中',
        6: '申诉通过',
        7: '申诉不通过'
      }
      return map[status] || '未知'
    },
    async getPageData(pageOption) {
      Object.assign(this.condition, pageOption)
      if (this.dateRange && this.dateRange.length === 2) {
        this.condition.startDate = this.dateRange[0]
        this.condition.endDate = this.dateRange[1]
      }
      this.pageData = await this.$lgh.get('api/clean/task/page', {
        enterpriseCode: this.userInfo.enterpriseCode,
        locationId: this.condition.location_id,
        workerId: this.condition.worker_id,
        status: this.condition.status,
        startDate: this.condition.startDate,
        endDate: this.condition.endDate,
        pageIndex: this.condition.pageIndex,
        pageSize: this.condition.pageSize
      })
    },
    async viewDetail(item) {
      await this.$lgh.openDialog({
        ins: detailTask,
        title: '任务详情',
        data: {
          taskId: item.task_id
        }
      })
      this.getPageData()
    },
    async triggerAiAudit(item) {
      try {
        await this.$lgh.get('api/clean/task/trigger-ai-audit', {
          taskId: item.task_id
        })
        this.$message.success('已触发AI审核，结果将在后台异步处理完成后更新')
        this.getPageData()
      } catch (err) {
        this.$message.error(err.message || '触发AI审核失败')
      }
    }
  }
}
</script>
